import { cloneElement, forwardRef, useImperativeHandle } from 'react';

import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicCodeVerifyPopup = dynamic(() => import('./code-verify'), { ssr: false });

const StudentCodeVerify = forwardRef(({ children, ...rest }: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();
  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });
  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: show
        })}
      {loaded && <DynamicCodeVerifyPopup {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default StudentCodeVerify;
